export enum SubjectAlternativeNameId {
  DNS = 2,
  IP_ADDRESS = 7,
}
